import type { JSX } from 'react';

import { SectionPlaceholder, type PlannedItem } from './Placeholder';

const PLANNED: readonly PlannedItem[] = [
  { title: '加载 .tlog：把回放接成一条普通链路（transport 已经具备）', owner: '@hgc/core tlog' },
  { title: '时间轴：播放/暂停/变速/跳转与进度显示', owner: 'analyze 后续' },
  { title: '曲线：把选中的遥测画成多轴时间序列', owner: 'analyze 后续' },
  { title: '事件标记：状态文本、模式切换、解锁点打在时间轴上', owner: 'analyze 后续' },
];

/**
 * 分析分区。
 *
 * 底层其实**已经就绪**（`.tlog` 的读端与 `ReplayTransport` 都能直接用），缺的是这一格的控件：
 * 时间轴与曲线。这里如实写出这个差别 —— "底层好了但界面没做"和"整个功能没做"
 * 对下一个接手的人是两条完全不同的信息。
 */
export function AnalyzeSection(): JSX.Element {
  return (
    <SectionPlaceholder
      title="分析"
      summary="遥测日志（.tlog）回放与曲线分析。"
      emptyTitle="回放通道已就绪，但时间轴与曲线还没有实现"
      emptyReason={
        '回放不需要另开一条数据通路：ReplayTransport 实现的就是普通 Transport 契约，' +
        '接上之后解析、归集、界面绑定全部复用。缺的只是这一格的控件（时间轴、曲线、事件标记）。'
      }
      items={PLANNED}
    />
  );
}
